export default str => `0${str}`.slice(-2);
